export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';
export const EXPIRED = 'EXPIRED';

export const STATUS_ACTIVE = 1;
export const STATUS_INACTIVE = 2;
export const STATUS_EXPIRED = 3;
